import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TeamCreateReq, teamApi } from '../api';
import { TEAM_LIST_QUERY_KEY } from '../queries';

export const useCreateTeam = () => {
  const queryClient = useQueryClient();

  const createTeamMutation = useMutation({
    mutationFn: (teamCreateReq: TeamCreateReq) => {
      return teamApi.createTeam(teamCreateReq).then(({ data }) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_LIST_QUERY_KEY });
    },
  });

  return {
    createTeam: createTeamMutation.mutateAsync,
    isCreatingTeam: createTeamMutation.isPending,
    ...createTeamMutation,
  };
};
